import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  // eslint-disable-next-line
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }
  // eslint-disable-next-line
  componentDidCatch(error, info) {
    throw error;
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{ textAlign: 'center' }}>
          <h1>Something went wrong.</h1>
          <p>Contact your administrator immediately</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
